export enum InvoiceStatus {
    New = 0,
    Paid = 1
}
